export const on = (selector, eventType, childSelector, eventHandler) => {
	const elements = document.querySelectorAll(selector)

	elements.forEach(item => {
		item.addEventListener(eventType, eventOnElement => {
			const closestChild = eventOnElement.target.closest(childSelector);
			if (closestChild && item.contains(closestChild)) {
				eventHandler(eventOnElement);
			}
		})
	})
}
